"use client";
import { avenirNextMedium } from '@/styles/fonts';
import clsx from 'clsx';
import React from 'react';
import { IntercomProvider, useIntercom } from 'react-use-intercom';

function GetInTouchButton() {
    const { show } = useIntercom();

    return (
        <a
            className={clsx(
                "text-[36px]",
                "cursor-pointer",
                "text-[#fff]",
                "underline",
                "cursor-pointer",
            )}
            onClick={show}
        >
            Get in touch with us here.
        </a>
    );
}

export default function GetInTouch() {
    return (
        <IntercomProvider appId={process.env.NEXT_PUBLIC_INTERCOM_APP_ID || ""}
            autoBoot={true}>
            <section className={clsx(
                "pt-[80px]",
                "bg-gradient-to-r",
                "from-[#22afeb]",
                "via-[#298bec]",
                "to-[#348aea]"
            )} id="contactus">
                <div className={clsx(
                    "pt-[25px]",
                    "pb-[60px]",
                    "sm:pb-[125px]",
                    "bg-gradient-to-r",
                    "from-[rgba(34,175,235,0)]",
                    "via-[rgba(37,169,235,1)]",
                    "to-[rgba(52,138,234,0)]",
                    "bg-[length:100%_100%]"
                )}>
                    <h1 className={clsx(
                        "text-[22px]",
                        "sm:text-[34px]",
                        "md:text-[48px]",
                        "text-[#fff]",
                        "text-center",
                        avenirNextMedium.className,
                        "font-[400]",
                        "mb-[10px]",
                    )}>More questions?</h1>
                    <p className={clsx(
                        "text-center",
                    )}>
                        <GetInTouchButton />
                    </p>
                </div>
            </section >
        </IntercomProvider>
    );
};
